import { HttpClient } from '@/shared/lib/http-client';

export const Download = () => ({
  download: async (url, filename = 'download.pdf') => {
    const response = await HttpClient.get(url, {}, { responseType: 'blob' });
    const blob = response.data;
    if (!blob) return false;

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
    return true;
  },
});